import { api } from '../../AxiosConfig';

class ServicosService {
    create(data: any) {
        return api.post('/servicos/create', data);
    }

    findAll() {
        return api.get('/servicos/findAll');
    }

    update(id: string, update: any) {
        return api.post('/servicos/update', { id, update });
    }

    updateOrder(items: { id: string; order: number }[]) {
        return api.put('/servicos/order', { items });
    }

    delete(id: string) {
        return api.post('/servicos/delete', { id });
    }

    getByEstabId(id: string, attendantId?: string) {
        const query = attendantId ? `?attendantId=${encodeURIComponent(attendantId)}` : '';
        return api.get(`/servicos/getByEstabId/${id}${query}`);
    }

    resolvePrices(payload: {
        estabId?: string;
        date: Date | string;
        attendantId?: string;
        servicosIds: string[];
    }) {
        return api.post('/servicos/resolve-prices', payload);
    }
}

export { ServicosService };
